
import SendButton from "@/components/base/api/SendButton"
import Modal from "@/components/base/modal/Modal"
import MentionableInput from "@/components/chat/input/MentionableInput"
import StreamChatMessage from "@/components/livestream/StreamChatMessage"
import sanitizeText from "@/utils/sanitize-text"

import Vue from "vue"
import vueSmoothScroll from "vue2-smooth-scroll"
import rules from "@/mixins/rules"
import { mapGetters } from "vuex"

import { mdiFaceMan, mdiChevronDown } from "@mdi/js"
Vue.use(vueSmoothScroll)
export default {
    components: { SendButton, Modal, StreamChatMessage, MentionableInput },
    mixins: [rules],
    data: () => {
        return {
            mdiFaceMan,
            mdiChevronDown,
            chatMessage: "",
            nicknameModal: false,
            newNickname: "",
            firstMessage: true,
            messageState: "unsent",
            messageError: "",
            maxMessageLength: 500,
            maxNicknameLength: 30,
            noScrollOffset: 25,
            showScroll: false,
            autoScroll: true,
            highlightedMessageID: 0,
            lastScrollTop: 0,
            messageThreshold: false,
            showMentionableCompanies: false,
            mentionedCompany: null,
            cachedMessage: "",
        }
    },
    computed: {
        ...mapGetters("livestream", [
            "nickname",
            "messages",
            "emojis",
            "selfMessageThreshold",
            "getCompaniesForMentioning",
        ]),
        salutation() {
            return !this.$auth.loggedIn || this.$can.trainee() ? "Dein" : "Ihr"
        },
        isMobile() {
            return this.$breakpoint.mdAndDown
        },
    },
    watch: {
        messages() {
            this.$nextTick(() => {
                let element = this.$refs["Chat"]
                if (!element) return
                let currentOffset = element.scrollTop + element.offsetHeight

                if (
                    element.scrollHeight >
                    currentOffset + this.noScrollOffset
                ) {
                    if (this.autoScroll) this.scrollDown()
                    else this.showScroll = true
                }
            })
        },
    },
    mounted() {
        this.$refs["Chat"].addEventListener("scroll", this.onScroll)
    },
    methods: {
        handleChatInput(newValue) {
            this.chatMessage = newValue
        },
        handleCompanyMention(company) {
            this.mentionedCompany = company
        },
        onScroll() {
            const container = this.$refs["Chat"]
            let currentOffset = container.scrollTop + container.offsetHeight
            if (currentOffset > this.lastScrollTop) {
                if (container.scrollHeight === currentOffset) {
                    this.showScroll = false
                    this.autoScroll = true
                }
                // downscroll code
            } else {
                this.showScroll = true
                this.autoScroll = false
                // upscroll code
            }
            this.lastScrollTop = currentOffset <= 0 ? 0 : currentOffset // For Mobile or negative scrolling
        },
        scrollDown() {
            this.showScroll = false
            this.$refs["Chat"].scrollTop = this.$refs["Chat"].scrollHeight
            this.autoScroll = true
        },
        isPrevFromSameCompany(index) {
            if (index === 0) return false
            return (
                this.messages[index - 1]?.user_id ===
                this.messages[index]?.user_id
            )
        },
        sendMessage() {
            if (
                this.newNickname &&
                this.newNickname.length <= this.maxNicknameLength
            ) {
                this.$store.dispatch("livestream/setNickname", this.newNickname)
                this.newNickname = ""
                // cache it because the input is already cleared
                this.chatMessage = this.cachedMessage
            }

            const isBusiness = this.$auth.user && this.$auth.user.business
            this.chatMessage = sanitizeText(this.chatMessage, isBusiness)
            if (this.mentionedCompany) {
                this.chatMessage = this.chatMessage.replace(
                    this.mentionedCompany.entityText,
                    `[@b:${this.mentionedCompany.value}]`
                )
            }

            let emojiPattern = /(?=(:[A-Za-z0-9-]+:))/gi
            const emojis = this.chatMessage.matchAll(emojiPattern) || []
            for (let emoji of emojis) {
                let emj = emoji[1].slice(1, -1)
                let emojiObject = this.emojis.find((e) => e.name === emj)
                if (
                    emojiObject &&
                    (!emojiObject?.is_premium || this.$auth.loggedIn)
                ) {
                    this.chatMessage = this.chatMessage.replace(
                        `:${emj}:`,
                        `[@e:${emj}]`
                    )
                }
            }
            if (
                this.chatMessage.length === 0 &&
                this.cachedMessage.length === 0
            ) {
                this.messageState = "error"
                this.messageError = "Nachricht konnte nicht gesendet werden"
                return setTimeout(() => {
                    this.messageState = "unsent"
                    this.messageError = ""
                }, 2000)
            }
            if (this.chatMessage.length > this.maxMessageLength) {
                this.messageState = "warning"
                this.messageError = "Nachricht zu lang"
                return
            }
            if (!this.nickname) {
                this.nicknameModal = true
                this.cachedMessage = this.chatMessage
                return
            }
            if (this.messageThreshold) {
                this.messageState = "warning"
                this.messageError = "Nicht so schnell!"
                return
            }
            this.messageThreshold = true
            setTimeout(() => {
                this.messageThreshold = false
            }, this.selfMessageThreshold * 1000)
            this.nicknameModal = false
            this.messageState = "pending"
            this.messageError = ""
            this.$store
                .dispatch("livestream/sendMessage", {
                    text: this.chatMessage,
                })
                .then(() => {
                    if (this.firstMessage) {
                        this.firstMessage = false
                        this.$refs["Chat"].scrollIntoView()
                    }
                    this.messageState = "success"
                    setTimeout(() => (this.messageState = "unsent"), 2000)
                })
                .catch(() => {
                    this.messageState = "error"
                    this.messageError = "Nachricht konnte nicht gesendet werden"
                })
            this.chatMessage = ""
            this.cachedMessage = ""
            this.mentionedCompany = null
        },
    },
}
